import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function GroupManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('group:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const groupSchema = {
    name: {
      label: 'Name',
      type: 'text',
      required: true,
      minWidth: '220px',
    },
    description: {
      label: 'Beschreibung',
      type: 'text',
      required: false,
      minWidth: '360px',
      previewInList: true,
      previewMaxLines: 3,
      useHyphens: true,
    },
    emailAlias: {
      label: 'E-Mail Alias',
      type: 'email',
      required: false,
      minWidth: '220px',
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={groupSchema}
      title='Neue Gruppe anlegen'
      resourceType='group'
      headerSearchPlaceholder='Gruppen durchsuchen'
      parentIsEditable={authCtx.checkRight('group:update')}
      options={{
        titleKey: 'name',
      }}
    />
    </Box>
  );
}

export default GroupManagement;
